// extracted by mini-css-extract-plugin
module.exports = {"block":"DiscrepancyOverview_block__AteqZ","metrics":"DiscrepancyOverview_metrics__1Ymx1","title":"DiscrepancyOverview_title__3XcXU"};